import { useCallback } from "react";
import { useApi } from "./useApi";
import { emailAccountService } from "../services/emailAccounts";
import {
  EmailAccountStatus,
  EmailAccountConnectResponse,
  EmailAccountDisconnectResponse,
} from "../types/emailAccount.types";
import { useSession } from "../context/SessionContext";
import { SUCCESS_MESSAGES } from "../i18n/success.pt-BR";

export function useEmailAccount() {
  const { metadata } = useSession();
  const statusApi = useApi<EmailAccountStatus>();
  const connectApi = useApi<EmailAccountConnectResponse>();
  const disconnectApi = useApi<EmailAccountDisconnectResponse>();

  const fetchStatus = useCallback(async () => {
    if (!metadata.email) return null;
    return statusApi.request(
      () => emailAccountService.getStatus(statusApi.apiFetch, metadata.email!),
      { showErrorToast: false },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [metadata.email, statusApi.apiFetch]);

  // Navegação de página inteira — o Google bloqueia a tela de consentimento
  // dentro de um iframe/popup, então o fluxo precisa sair do app mesmo.
  const connectGoogle = useCallback(async () => {
    if (!metadata.email) return;
    const returnTo = window.location.pathname + window.location.search;
    const result = await connectApi.request(
      () => emailAccountService.getGoogleConnectUrl(connectApi.apiFetch, metadata.email!, returnTo),
    );
    if (result?.authorization_url) {
      window.location.href = result.authorization_url;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [metadata.email, connectApi.apiFetch]);

  const disconnectGoogle = useCallback(async () => {
    if (!metadata.email) return null;
    return disconnectApi.request(
      () => emailAccountService.disconnectGoogle(disconnectApi.apiFetch, metadata.email!),
      { successMessage: SUCCESS_MESSAGES.emailAccountDisconnected },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [metadata.email, disconnectApi.apiFetch]);

  return {
    status: statusApi.data,
    fetchStatus,
    connectGoogle,
    disconnectGoogle,
    statusLoading: statusApi.loading,
    statusFailed: Boolean(statusApi.error),
    connecting: connectApi.loading,
    disconnecting: disconnectApi.loading,
  };
}
